import script from "./AppHead.vue?vue&type=script&lang=js"
export * from "./AppHead.vue?vue&type=script&lang=js"

export default script